import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosObj } from "../../../config/apiClients";
import { PendingWithDrawalState } from "../../types";

const initialState: PendingWithDrawalState = {
  isLoading: false,
  requests: [],
  pagination: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
}

export const getAllWithDrawalRequests = createAsyncThunk(
  "/withdraw/getAll",
  async (
    {
      paramPage,
      paramLimit,
      status,
      search,
    }: {
      paramPage: number;
      paramLimit: number;
      status?: string;
      search?: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosObj.get(
        `/withdraw/getAll?paramPage=${paramPage}&paramLimit=${paramLimit}${status ? `&status=${status}` : ""}${search ? `&search=${encodeURIComponent(search)}` : ""}`);
      return response.data
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Requests' });
    }
  }
)

export const updateWithDrawalRequestStatus = createAsyncThunk(
  "/withdraw/status/update",
  async ({ id, status, transactionBank }: { id: string; status: string, transactionBank?: string }, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/withdraw/status/update', { _id: id, status, transactionBank });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Requests' });
    }
  }
);

const pendingWithDrawalSlice = createSlice({
  name: "WithDrawalRequest",
  initialState,
  reducers: {
    updateRequestStatus: (state, action) => {
      const requestStatus = action.payload;
      const request = state.requests.find((request) => request._id === requestStatus.id)
      if (request) {
        request.status = requestStatus.status;
      }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getAllWithDrawalRequests.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllWithDrawalRequests.fulfilled, (state, action) => {
        state.isLoading = false;
        state.requests = action.payload.payload.kAllWithdraws;
        state.pagination = {
          totalItems: action.payload.payload.totalItems,
          currentPage: action.payload.payload.page,
          totalPages: action.payload.payload.totalPages,
          hasNextPage: action.payload.payload.hasNextPage
        };
      })
      .addCase(getAllWithDrawalRequests.rejected, (state) => {
        state.isLoading = false;
        state.requests = []
      })
  }
})

export const { updateRequestStatus } = pendingWithDrawalSlice.actions;

export default pendingWithDrawalSlice.reducer;